<template>
  <OnboardingInfo @next="handleClick">
    <template #heading>
      <span class="text-gray-400">Designated by sovereign governments.</span>
      <span class="text-gray-800 ml-1">The global standard for copyright.</span>
    </template>
    <template #body>
      <p>Most copyright tools are private services.</p>
      <p class="mt-[18px]">
        <span class="font-medium">
          Dacr is official infrastructure operating under government
          designation</span
        >, recognized in 180+ countries under the Berne Convention and
        TRIPS—including the United States.
      </p>
      <p class="mt-[18px]">The difference isn’t features. It’s authority.</p>
    </template>
  </OnboardingInfo>
</template>

<script setup lang="ts">
import OnboardingInfo from '@/features/onboarding/components/OnboardingInfo.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({ step: 10 })

  onboardingStore.goToNextStep()
}
</script>
